import { createElement, type ComponentType } from "react";
import type { StepTypeProps } from "./types";
import WebSmStart from "./WebSmStart_type";
import WebSmOrder from "./WebSmOrder_type";
import WebSmDoors from "./WebSmDoors_type";
import WebSmHandler from "./WebSmHandler_type";
import WebSmDifficulty from "./WebSmDifficulty_type";
import WebSmCase from "./WebSmCase_type";
import WebSmDelivered from "./WebSmDelivered_type";
import WebSmReject from "./WebSmReject_type";
import WebSmReconsider from "./WebSmReconsider_type";
import WebSmWayback from "./WebSmWayback_type";
import WebSmMissionLive from "./WebSmMissionLive_type";
import WebSmDebrief from "./WebSmDebrief_type";
import WebSmSignOff from "./WebSmSignOff_type";
import WebSmName from "./WebSmName_type";
import WebSmMissionHub from "./WebSmMissionHub_type";
import WebSmMissionStep from "./WebSmMissionStep_type";
import WebSmStamp from "./WebSmStamp_type";

/**
 * StepType → renderer, borrowed from Glow's StepTypes/*_type.jsx (the same
 * templates the builder preview and live player use). Adding a new web step
 * type = drop its template here.
 */
export const STEP_TYPE_COMPONENTS: Record<
  string,
  ComponentType<StepTypeProps>
> = {
  WebSmStart,
  WebSmOrder,
  WebSmDoors,
  WebSmHandler,
  WebSmDifficulty,
  WebSmCase,
  WebSmDelivered,
  WebSmReject,
  WebSmReconsider,
  WebSmWayback,
  WebSmMissionLive,
  WebSmVoiceDebrief: (props) =>
    createElement(WebSmMissionLive, { ...props, reportMode: "voice" }),
  WebSmWrittenReport: (props) =>
    createElement(WebSmMissionLive, { ...props, reportMode: "written" }),
  WebSmDebrief,
  WebSmSignOff,
  WebSmName,
  WebSmMissionHub,
  WebSmMissionStep,
  WebSmStamp,
};

export function resolveStepType(
  stepType: string,
): ComponentType<StepTypeProps> | null {
  return STEP_TYPE_COMPONENTS[stepType] ?? null;
}
